export class Data {
  dateOptions: Object;
  apiBaseUrl: string;
  webContentType: string;
  contentJSON: string;
  WRTManagerApiPath: string;
  FileDownloadPath: string;
  ApiDownloadPath: string;
}

export const DataConfig = {
  dateOptions: {
    monthLabels: [
      {
        month: '全部',
        value: 0
      },
      {
        month: '1月',
        value: 1
      },
      {
        month: '2月',
        value: 2
      },
      {
        month: '3月',
        value: 3
      },
      {
        month: '4月',
        value: 4
      },
      {
        month: '5月',
        value: 5
      },
      {
        month: '6月',
        value: '6'
      },
      {
        month: '7月',
        value: '7'
      },
      {
        month: '8月',
        value: '8'
      },
      {
        month: '9月',
        value: '9'
      },
      {
        month: '10月',
        value: '10'
      },
      {
        month: '11月',
        value: '11'
      },
      {
        month: '12月',
        value: '12'
      }
    ]
  },
  //在本機測試 或 更新到正式機時，apiBaseUrl && ApiDownloadPath 要記得選對!!
  apiBaseUrl:'/WRTInfoAPI/api/',
  // apiBaseUrl: 'http://localhost/NewWRTInfoAPI/api/',  //本機路徑
  ApiDownloadPath: '/WRTInfoAPI/',
  // ApiDownloadPath: 'http://localhost/NewWRTInfoAPI/', //本機路徑

  WRTManagerApiPath: '../WRTManageAPI/',
  FileDownloadPath: 'FileUpload/Temporary/',
  SketchDownloadPath: 'FileUpload/Sketch/',
  fileBaseUrl: '/',
  webContentType: 'Content-Type',
  contentJSON: 'application/json',
}
